// import React from "react";

// const Erpsolution = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.imageSection}>
//         <img src="/image/erp2.png" alt="ERP Solutions" style={styles.image} />
//       </div>
//       <div style={styles.textSection}>
//         <h2 style={styles.title}>Why Choose Our ERP Platform Solutions?</h2>
//         <p style={styles.description}>
//           Our team specializes in developing customized ERP solutions that
//           streamline business operations, enhance efficiency, and drive growth.
//           We integrate powerful technology with deep industry knowledge to
//           create systems tailored to your organization's needs.
//         </p>
//         <p style={styles.description}>
//           Whether you need an ERP system for inventory management, accounting,
//           HR, or customer relationship management (CRM), we ensure seamless
//           integration across all departments to improve workflow and data
//           accuracy.
//         </p>
//         <p style={styles.description}>
//           Our ERP solutions are scalable, customizable, and designed to adapt to
//           your business growth, providing real-time insights and empowering
//           data-driven decisions at every level of your organization.
//         </p>
//         <p style={styles.description}>
//           With a focus on user-friendly interfaces and robust security features,
//           we deliver ERP platforms that not only meet current needs but also
//           evolve with your business.
//         </p>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "40px 5%",
//     backgroundColor: "white",
//     boxSizing: "border-box",
//     flexWrap: "wrap",
//   },
//   textSection: {
//     width: "50%",
//     paddingLeft: "40px",
//     textAlign: "left",
//   },
//   title: {
//     fontSize: "32px",
//     fontWeight: "bold",
//     marginBottom: "20px",
//     color: "black",
//   },
//   description: {
//     fontSize: "16px",
//     lineHeight: "1.6",
//     marginBottom: "15px",
//     textAlign: "justify",
//     color: "black",
//   },
//   imageSection: {
//     width: "45%",
//     textAlign: "center",
//   },
//   image: {
//     width: "100%",
//     maxWidth: "600px",
//     height: "auto",
//     borderRadius: "8px",
//   },
//   "@media (max-width: 768px)": {
//     container: {
//       flexDirection: "column",
//       padding: "20px",
//     },
//     textSection: {
//       width: "100%",
//       paddingLeft: "0",
//       order: 2,
//     },
//     imageSection: {
//       width: "100%",
//       order: 1,
//       marginBottom: "30px",
//     },
//     title: {
//       fontSize: "28px",
//       textAlign: "center",
//     },
//     description: {
//       fontSize: "14px",
//       textAlign: "left",
//     },
//   },
//   "@media (max-width: 480px)": {
//     title: {
//       fontSize: "24px",
//     },
//     description: {
//       fontSize: "13px",
//     },
//   },
// };

// // Convert the styles object to inline styles and media queries
// const responsiveStyles = `
//   @media (max-width: 768px) {
//     .erp-container {
//       flex-direction: column;
//       padding: 20px;
//     }
//     .erp-text-section {
//       width: 100%;
//       padding-left: 0;
//       order: 2;
//     }
//     .erp-image-section {
//       width: 100%;
//       order: 1;
//       margin-bottom: 30px;
//     }
//     .erp-title {
//       font-size: 28px;
//       text-align: center;
//     }
//     .erp-description {
//       font-size: 14px;
//       text-align: left;
//     }
//   }
//   @media (max-width: 480px) {
//     .erp-title {
//       font-size: 24px;
//     }
//     .erp-description {
//       font-size: 13px;
//     }
//   }
// `;

// export default Erpsolution;




import React from "react";

const Erpsolution = () => {
  return (
    <>
      {/* Responsive CSS */}
      <style>
        {`
          .erp-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 40px 5%;
            background-color: white;
            box-sizing: border-box;
            flex-wrap: wrap;
          }
          .erp-image-section {
            width: 45%;
            text-align: center;
          }
          .erp-image {
            width: 100%;
            max-width: 600px;
            height: auto;
            border-radius: 8px;
          }
          .erp-text-section {
            width: 50%;
            padding-left: 40px;
            text-align: left;
          }
          .erp-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: black;
          }
          .erp-description {
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: justify;
            color: black;
          }

          /* Tablet */
          @media (max-width: 768px) {
            .erp-container {
              flex-direction: column;
              padding: 20px;
            }
            .erp-text-section {
              width: 100%;
              padding-left: 0;
              order: 2;
            }
            .erp-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 30px;
            }
            .erp-title {
              font-size: 28px;
              text-align: center;
            }
            .erp-description {
              font-size: 14px;
              text-align: left;
            }
          }

          /* Mobile */
          @media (max-width: 480px) {
            .erp-title {
              font-size: 24px;
            }
            .erp-description {
              font-size: 13px;
            }
          }
        `}
      </style>

      {/* Component Structure */}
      <div className="erp-container">
        {/* Left Side - Image */}
        <div className="erp-image-section">
          <img
            src="/image/erp2.png"
            alt="ERP Solutions"
            className="erp-image"
          />
        </div>

        {/* Right Side - Text */}
        <div className="erp-text-section">
          <h2 className="erp-title">Why Choose Our ERP Platform Solutions?</h2>
          <p className="erp-description">
            Our team specializes in developing customized ERP solutions that
            streamline business operations, enhance efficiency, and drive growth.
            We integrate powerful technology with deep industry knowledge to
            create systems tailored to your organization's needs.
          </p>
          <p className="erp-description">
            Whether you need an ERP system for inventory management, accounting,
            HR, or customer relationship management (CRM), we ensure seamless
            integration across all departments to improve workflow and data
            accuracy.
          </p>
          <p className="erp-description">
            Our ERP solutions are scalable, customizable, and designed to adapt
            to your business growth, providing real-time insights and empowering
            data-driven decisions at every level of your organization.
          </p>
          <p className="erp-description">
            With a focus on user-friendly interfaces and robust security
            features, we deliver ERP platforms that not only meet current needs
            but also evolve with your business.
          </p>
        </div>
      </div>
    </>
  );
};

export default Erpsolution;
